import profileService from "@/services/merchant";
import { useQuery } from "@tanstack/react-query";

function useGetMerchant() {
  return useQuery(["getMerchant"], profileService.getMerchant);
}

export default useGetMerchant;
